'use client';

export { default } from './Typography';
export { default as typographyClasses } from './typographyClasses';
export * from './typographyClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Typography/index.js
// module id = 94
// module chunks = 25